import {
  getSchema as getSchema1,
  uiSchema as uiSchema1,
} from "./schema.followUpRegisteredMail.1";
import { IExtraData } from "./schema.followUpRegisteredMail.types";
import { getInitialValues } from "./schema.followUpRegisteredMail.utils";

// eslint-disable-next-line import/no-default-export
export default (extraData: IExtraData) => {
  const initialValues = getInitialValues(extraData);
  return [
    {
      schema: getSchema1(initialValues),
      uiSchema: uiSchema1(),
    },
  ];
};
